import React from 'react';

import { Spinner } from '@admin/components/spinner';
import { client } from '@admin/libraries/apollo';
import { useAccountMaterialsQuery } from '@admin/schema';

export const Materials: React.FC<{ accountID: string }> = ({ accountID }) => {
  const { data, loading } = useAccountMaterialsQuery({
    variables: { accountID },
    client,
    fetchPolicy: 'cache-and-network',
  });

  if (loading && !data) {
    return <Spinner />;
  }

  return (
    <div>
      <strong>Materials Plan: </strong>
      <span>{data?.account.materialsSummary}</span>
    </div>
  );
};
